var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"33355"},[_vm._t("default",null,{"apiKey":_vm.apiKey,"loading":_vm.isloading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }